export const TESTING_CALENDLY = "https://calendly.com/agorz-contractor/15min";
